import {Grid} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {digitsEnToFa, digitsFaToEn} from 'persian-tools2';
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/card-style';
import postMeal from 'assets/img/AfterMeal.svg';
import preMeal from 'assets/img/postPurple.svg';
import NoMeal from 'assets/img/undefinedMeal.svg';
import styled from 'styled-components';
import {useMediaQuery} from 'hooks/useMediaQuery';
import {parseGlucoseCount} from "utils/functions-utils";

const useStyles = makeStyles(styles);

const Card = ({cardData}) => {
    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const classes = useStyles();
    const {time, testResult, glucoseStatus, mealStatus, weekday} =
    cardData || {};
    const labelColor =
        glucoseStatus === 0
            ? 'var(--medium-green)'
            : glucoseStatus === 1
                ? 'var(--light-orange)'
                : glucoseStatus === 2
                    ? 'var(--pink)'
                    : '';
    const mealImages = [NoMeal, postMeal, preMeal];
    const mealText = ['', 'postmeal', 'premeal'];

    const MobileCard = () => (
        <Grid
            container
            className={classes.cardContainer}
            style={{border: `1px solid ${labelColor}`}}
        >
            {/*---------------------------- first row -----------------------------*/}
            <Grid container alignItems="center">
                <Grid item xs={5.5} className={classes.date}>
                    {weekday ? digitsFaToEn(weekday) : ''}
                </Grid>
                <Grid
                    item
                    xs={2}
                    className={classes.sugarNumber}
                    style={{color: labelColor}}
                >
                    {testResult}
                </Grid>
                <Grid item xs={4.5} className={classes.reason}>
                    {mealText[mealStatus]}
                </Grid>
            </Grid>
            {/* ------------------- second row -----------------*/}
            <Grid container className={classes.secondRowContainer}>
                <Grid item xs={5.5} className={classes.clock}>
                    {time}
                </Grid>
                <Grid xs={2} item className={classes.sugarUnit}>
                    {Number.isInteger(testResult) &&
                        <>
                            <span style={{color: labelColor}}>mg/dl</span>
                            <FiberManualRecordIcon
                                style={{color: labelColor}}
                                className={classes.fiberStyle}
                            />
                        </>
                    }
                </Grid>
                <Grid item xs={4.5} className={classes.meal}>
                    <img src={mealImages[mealStatus]} alt=""/>
                </Grid>
            </Grid>
        </Grid>
    );
    const WebCard = () => (
        <StyledWebCard color={labelColor}>
            <div className="test-date">
                <span>{weekday ? digitsFaToEn(weekday) : ''}</span>
                <span className="time">{time}</span>
            </div>
            <div className="test-number">
                <span>
                    {testResult}
                </span>
                {Number.isInteger(testResult) &&
                <span className="test-number_unit">mg/dl </span>}
            </div>
            <div className="test-meal_status">
                <span>{mealText[mealStatus]}</span>
                <span>
          <img src={mealImages[mealStatus]} alt=""/>
        </span>
            </div>
        </StyledWebCard>
    );
    return isDesktop ? <WebCard/> : <MobileCard/>;
};

export default Card;

const StyledWebCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px 19px;
  border-radius: 16px;
  border: ${(props) => `2px solid ${props.color}`};

  .test-date {
    display: flex;
    gap: 30px;
    align-items: center;
    color: #753cbe;
    width: 45%;
    font-size: 16px;
    font-family: 'dana-bold';
  }

  .time {
    font-size: 20px;
    direction: ltr;
    font-weight: 400;
  }

  .test-number {
    font-family: 'dana-bold';
    font-size: 24px;
    letter-spacing: 5px;
    color: ${({color}) => color};
  }

  .test-number span:nth-child(1) {
    letter-spacing: 2px;
  }

  .test-number_unit {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    padding-left: 5px;
  }

  .test-meal_status {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .test-meal_status span {
    padding-left: 10px;
    color: #753cbe;
    font-size: 14px;
    font-family: 'dana-bold';
  }
`;
